import React from "react";
import Typography from "@material-ui/core/Typography";

export const WhenAndWhere = ({ refProp }) => {
  return (
    <div ref={refProp}>
      <Typography variant="h3" component="h2">
        <u>When And Where?</u>
      </Typography>
      <p>
        We primarily play at 2000 UTC, this caters for our international player
        base and is accessible to a wide range of time zones. We always hold our
        main event on Sunday, and this is usually supplemented by Friday and
        Saturday missions as well.
      </p>
      <p>
        Weekdays often see our server being used for casually organized co-op
        missions such as Hearts and minds, Insurgency and Liberation.
      </p>
    </div>
  );
};

export default WhenAndWhere;
